import {
  fontBodyMini,
  fontBodyMiniMedium,
  fontCaption,
} from '../../styles/typographyNew';
import { getEnvUrl } from '../../components/Picto/logic';
import { Rating } from '../../components/Rating';
import { classNames } from '../../utils/style';
import React from 'react';

export type CardRating = {
  review: string;
  name: string;
  rating: number;
  origin?: string;
  className?: string;
};
export const CardRating = ({
  review,
  name,
  rating,
  origin: reviewOrigin,
  className,
}: CardRating) => {
  return (
    <div
      className={classNames(
        'CardRating',
        'w-[400px] mx-auto bg-[#F7F9FC]',
        'border border-[#EEF2F7]',
        'p-24',
        'rounded-[20px]',
        'flex flex-col justify-between overflow-hidden',
        className,
      )}
    >
      <p className={classNames(fontBodyMini, 'text-[#364A61]')}>{review}</p>
      <div className="flex items-center mt-12 ">
        {reviewOrigin && (
          <div
            className={classNames(
              'h-[44px] w-[44px] p-[10px] rounded-full border border-[#00000014]',
              'flex justify-between items-center',
            )}
          >
            <img
              src={`${getEnvUrl()}/icon/${reviewOrigin}.svg`}
              width={40}
              height={40}
              alt=""
            />
          </div>
        )}
        <div className="ml-12">
          <div className={classNames(fontBodyMiniMedium, 'text-[#042040]')}>
            {name}
          </div>
          <div className={classNames(fontCaption, 'text-[#485B70]')}>
            {rating}/5{' '}
            <Rating
              rating={rating}
              className="inline-block align-text-top w-[80px]"
              widthStar={16}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
